import { render, staticRenderFns } from "./rating.vue?vue&type=template&id=02931611&scoped=true"
import script from "./rating.vue?vue&type=script&lang=js"
export * from "./rating.vue?vue&type=script&lang=js"
import style0 from "./rating.vue?vue&type=style&index=0&id=02931611&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02931611",
  null
  
)

export default component.exports